<script>
    export let tooltip;
</script>

<style>
    .toolbar__button {
        border: none;
        padding: 1px;
        width: 25px;
        height: 25px;
        margin: 5px;
        border-radius: 3px;
        background-color: var(--white);
    }

    .toolbar__button:hover {
        background-color: var(--green);
    }
</style>

<button
    on:click
    class="toolbar__button"
    title={tooltip}>
    <slot />
</button>
